module.exports = __webpack_public_path__ + "img/hedgehog.116f990.png";